(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-resource-links"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-resource-carousel')) {
    class CgResourceCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.track = this.querySelector('[data-carousel-track]');
        this.cards = Array.from(this.querySelectorAll('.cg-resource-card'));
        this.originalCardCount = this.cards.length;
        this.previousButton = this.closest('.cg-resource-links')?.querySelector('[data-carousel-prev]');
        this.nextButton = this.closest('.cg-resource-links')?.querySelector('[data-carousel-next]');
        this.autoplay =
          this.dataset.autoplay === 'true' &&
          this.originalCardCount > 1 &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = Number(this.dataset.interval) || 7000;
        this.timer = null;
        this.normalizeTimer = null;
        this.activeIndex = this.originalCardCount;

        if (!this.viewport || !this.track || this.originalCardCount < 2) return;

        this.#createLoop();
        this.#scrollToCard(this.activeIndex, 'instant');

        this.previousButton?.addEventListener('click', () => {
          this.showCard(this.currentIndex - 1);
          this.restart();
        });
        this.nextButton?.addEventListener('click', () => {
          this.showCard(this.currentIndex + 1);
          this.restart();
        });
        this.viewport.addEventListener('scrollend', this.handleScrollEnd);
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.normalizeTimer) window.clearTimeout(this.normalizeTimer);
        this.viewport?.removeEventListener('scrollend', this.handleScrollEnd);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      get currentIndex() {
        return this.activeIndex ?? this.originalCardCount;
      }

      #createLoop() {
        const originals = this.cards;
        const before = originals.map((card) => this.#cloneCard(card));
        const after = originals.map((card) => this.#cloneCard(card));

        this.track.prepend(...before);
        this.track.append(...after);
        this.cards = Array.from(this.track.querySelectorAll('.cg-resource-card'));
      }

      #cloneCard(card) {
        const clone = card.cloneNode(true);
        clone.removeAttribute('data-shopify-editor-block');
        clone.removeAttribute('data-shopify-editor-block-id');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      #getClosestCardIndex() {
        const viewportLeft = this.viewport.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - viewportLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      #getCardScrollLeft(card) {
        const viewportRect = this.viewport.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        return Math.max(0, this.viewport.scrollLeft + cardRect.left - viewportRect.left);
      }

      #scrollToCard(index, behavior = 'smooth') {
        const card = this.cards[index];
        if (!card) return;

        this.viewport.scrollTo({
          left: this.#getCardScrollLeft(card),
          top: 0,
          behavior,
        });
      }

      #scheduleLoopNormalization() {
        if (this.normalizeTimer) window.clearTimeout(this.normalizeTimer);
        this.normalizeTimer = window.setTimeout(this.normalizeLoop, 700);
      }

      normalizeLoop = () => {
        this.normalizeTimer = null;
        let normalizedIndex = this.activeIndex;

        if (normalizedIndex >= this.originalCardCount * 2) {
          normalizedIndex -= this.originalCardCount;
        } else if (normalizedIndex < this.originalCardCount) {
          normalizedIndex += this.originalCardCount;
        }

        if (normalizedIndex === this.activeIndex) return;

        this.activeIndex = normalizedIndex;
        this.#scrollToCard(normalizedIndex, 'instant');
      };

      showCard(index) {
        const nextIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        this.activeIndex = nextIndex;
        this.#scrollToCard(nextIndex);
        this.#scheduleLoopNormalization();
      }

      handleScrollEnd = () => {
        this.activeIndex = this.#getClosestCardIndex();
        this.normalizeLoop();
      };

      start = () => {
        if (!this.autoplay || document.hidden || this.timer) return;
        this.timer = window.setInterval(() => this.showCard(this.currentIndex + 1), this.interval);
      };

      stop = () => {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      };

      restart() {
        this.stop();
        this.start();
      }

      handleVisibility = () => {
        if (document.hidden) this.stop();
        else this.start();
      };
    }

    customElements.define('cg-resource-carousel', CgResourceCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
